import { IntegrationMethod, SetState, StoreData } from "../types";

export const setIntegrationMethod = (set: SetState<StoreData>) => (integrationMethod?: IntegrationMethod) =>
  set({ integrationMethod });
